// @flow
import * as React from 'react'
import tw from 'tailwind-styled-components'

type Props = {
  children: React.Node,
  container?: boolean,
  $marginTop?: boolean,
  $fluid?: boolean,
  $centerContainer?: boolean,
  className?: string,
}

const PageWrapper: React.ComponentType<Props> = tw.div`
${(props: Props) => {
  if (props.$fluid) {
    return `
      h-full
    `
  }

  return `
    pt-6
    max-w-screen-xl
    mx-auto
    px-3
  `
}}

  ${(props: Props) =>
    props.container &&
    `
      max-w-screen-md
      mx-auto
      px-3
  `}

  ${(props: Props) => {
    if (!props.$centerContainer) return ''

    return `
      pt-0
      h-screen
      flex
      flex-col
      items-center
      justify-center
    `
  }}

  ${(props: Props) => {
    if (!props.$marginTop) return ''

    return `
      pt-32
    `
  }}
`

export default PageWrapper
